import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";

// Optional customer WhatsApp + "Send invoice on WhatsApp" (link to the public receipt page). Never blocks the sale.
export function SendInvoice({ saleId, defaultPhone = "", branchId, testid = "send-invoice" }) {
  const [to, setTo] = useState(defaultPhone || "");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      await api.post(`/sales/${saleId}/whatsapp`, { to }, branchId ? { headers: { "X-Branch-Id": branchId } } : undefined);
      setSent(true);
      toast.success("Invoice sent on WhatsApp");
    } catch (e) {
      toast.error(e.response?.status === 400 ? errMsg(e) : "WhatsApp message couldn't be sent");
    } finally { setBusy(false); }
  };
  return (
    <div className="flex gap-2" data-testid={testid}>
      <Input type="tel" inputMode="tel" placeholder="Customer WhatsApp, e.g. +923001234567" value={to} onChange={(e) => { setTo(e.target.value); setSent(false); }}
        className="h-11" data-testid={`${testid}-input`} />
      <button onClick={go} disabled={!to.trim() || busy} data-testid={`${testid}-button`}
        className="flex h-11 shrink-0 items-center gap-1.5 rounded-xl bg-emerald-600 px-3 text-sm font-semibold text-white transition-colors hover:bg-emerald-500 disabled:opacity-50">
        <MessageCircle className="h-4 w-4" />{sent ? "Sent" : busy ? "Sending…" : "Send invoice on WhatsApp"}
      </button>
    </div>
  );
}
